import { createContext, useContext } from 'react';

const AudioFileParentBoundaryContext = createContext(null);

export const AudioFileParentBoundaryProvider = ({ children, value }) =>
    <AudioFileParentBoundaryContext.Provider value={value}>{children}</AudioFileParentBoundaryContext.Provider>;

export const useAudioFileParentBoundary = () => {
    const context = useContext(AudioFileParentBoundaryContext);
    if (context == null) {
        throw new Error('useAudioFileParentBoundary must be used within a AudioFileParentBoundaryContext');
    }
    return context;
}